import React, { useState, useEffect } from "react";
import {
  H2,
  P,
  InputContainer,
  LabelContainer,
  PromoContainer,
  Strong,
} from "../../styles";
import Button from "../../components/Button/Button";
import { useTranslation } from "react-i18next";
import axios from "axios";
import NvidiaContainer from "../../hoc/NvidiaContainer";
import { ButtonsContainer } from "../../components/Button/styles";

const Gfn = ({ currentPlan, productId, locale }) => {
  const { t } = useTranslation();
  const [subscriptionTitle, setSubscriptionTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [subscriptionType, setSubscriptionType] = useState("");
  const [preOrderUpsell, setPreOrderUpsell] = useState(false);
  useEffect(() => {
    // only calling product details when the user has a subscription
    if (productId) {
      const [lang, region] = locale.split("-");
      let productUri = productId
        ? `${PRODUCT_URI_BASE}/${lang}_${region.toUpperCase()}_${productId}.json`
        : "";

      getProductDetails(productUri);
    } else {
      setLoading(false);
    }
  }, []);

  const getProductDetails = async (productUri) => {
    const productInfo = await axios.get(productUri);
    setSubscriptionTitle(currentPlan);
    setSubscriptionType(productInfo.data.productType);
    setLoading(false);
  };

  const getConfig = async () => {
    const config = await axios.get(GFN_CONFIG);
    setPreOrderUpsell(config?.data?.dynamicConfigs?.preorderEnabled);
  };

  const getCTAConfig = (subscriptionType, ctaType) => {
    if (ctaType === "main") {
      // Main CTA
      if (!subscriptionType) {
        // New users
        return {
          label: t("Join now"),
          onClick: () => {
            location.href = `/${locale}${MANAGE_GFN_URL}`;
          },
        };
      } else {
        // Paid, Free, Promotional users
        return {
          label: t("Play Now"),
          onClick: () => {
            location.href = PLAY_NOW_GFN_URL;
          },
        };
      }
    } else {
      // Secondary CTA
      if (!subscriptionType) {
        // New users
        return {
          label: t("Learn more"),
          onClick: () => {
            window.open(`/${locale}${MKT_GFN_URL}`);
          },
        };
      } else if (
        subscriptionType === "FREE" ||
        subscriptionType === "PROMOTIONAL"
      ) {
        // Free and Promotional users with upgrade option
        return {
          label: t("Upgrade"),
          onClick: () => {
            location.href = `/${locale}${MANAGE_GFN_URL}`;
          },
        };
      } else if (subscriptionType === "PAID") {
        // Paid users
        return {
          label: t("Manage"),
          onClick: () => {
            location.href = `/${locale}${MANAGE_GFN_URL}`;
          },
        };
      }
    }
  };

  if (loading) {
    return null;
  }

  const promoText =
    !subscriptionType || subscriptionType === "FREE"
      ? t(
          "Special Upgrade Offer! Get the game Crysis Remastered ($29.99 USD value) FREE with 6-month Priority membership upgrade or GeForce NOW RTX 3080 membership purchase."
        )
      : null;

  return (
    <NvidiaContainer>
      <H2>{t("GeForce NOW")}</H2>
      {productId ? (
        <>
          <P>{t("View your membership info")}</P>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <LabelContainer>{t("Membership type")}</LabelContainer>
            <InputContainer>{subscriptionTitle}</InputContainer>
          </div>
        </>
      ) : (
        <P>
          {t(
            "GeForce NOW allows you to experience legendary GeForce gaming anywhere, by streaming your library of PC games across all your devices from the cloud."
          )}
        </P>
      )}

      <ButtonsContainer>
        <Button
          label={getCTAConfig(subscriptionType, "main")?.label}
          clickHandler={getCTAConfig(subscriptionType, "main")?.onClick}
        />
        <Button
          label={getCTAConfig(subscriptionType, "secondary")?.label}
          clickHandler={getCTAConfig(subscriptionType, "secondary")?.onClick}
          theme="alt"
        />
      </ButtonsContainer>

      {preOrderUpsell && promoText && (
        <PromoContainer>{promoText}</PromoContainer>
      )}
    </NvidiaContainer>
  );
};
export default Gfn;
